import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import pina from "./store";
import "@/theme/index.scss";
import 'vditor/dist/index.css';
import 'vditor/dist/css/content-theme/light.css';
import 'vditor/dist/js/highlight.js/styles/github.css';
import 'vditor/dist/js/icons/ant';
import ElementPlus from 'element-plus'
import "@/assets/svgIcons/iconfont.js";
import 'element-plus/dist/index.css';
import SvgIcon from "@/components/svgIcon.vue";
import PageHeader from "@/components/PageHeader.vue";
import toMD5 from "@/utils/md5";
import * as api from "@/api/BaseAPI";
import * as dialog from "@/utils/dialog";
import * as auth from "@/utils/auth";
import * as util from "@/utils/util";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { useUmoEditor } from '@umoteam/editor';

import 'prism-code-editor/prism/languages/bash'
import 'prism-code-editor/prism/languages/css'
import 'prism-code-editor/prism/languages/css-extras'
import 'prism-code-editor/prism/languages/ini'
import 'prism-code-editor/prism/languages/kotlin'
import 'prism-code-editor/prism/languages/xml'
import 'prism-code-editor/prism/languages/markup'
import 'prism-code-editor/prism/languages/r'
import 'prism-code-editor/prism/languages/basic'
import 'prism-code-editor/prism/languages/vbnet'
import 'prism-code-editor/prism/languages/c'
import 'prism-code-editor/prism/languages/opencl'
import 'prism-code-editor/prism/languages/diff'
import 'prism-code-editor/prism/languages/java'
import 'prism-code-editor/prism/languages/less'
import 'prism-code-editor/prism/languages/objectivec'
import 'prism-code-editor/prism/languages/ruby'
import 'prism-code-editor/prism/languages/sql'
import 'prism-code-editor/prism/languages/wasm'
import 'prism-code-editor/prism/languages/cpp'
import 'prism-code-editor/prism/languages/go'
import 'prism-code-editor/prism/languages/javascript'
import 'prism-code-editor/prism/languages/js-templates'
import 'prism-code-editor/prism/languages/jsx'
import 'prism-code-editor/prism/languages/lua'
import 'prism-code-editor/prism/languages/perl'
import 'prism-code-editor/prism/languages/python'
import 'prism-code-editor/prism/languages/rust'
import 'prism-code-editor/prism/languages/swift'
import 'prism-code-editor/prism/languages/clike'
import 'prism-code-editor/prism/languages/csharp'
import 'prism-code-editor/prism/languages/graphql'
import 'prism-code-editor/prism/languages/json'
import 'prism-code-editor/prism/languages/makefile'
import 'prism-code-editor/prism/languages/scss'
import 'prism-code-editor/prism/languages/typescript'
import 'prism-code-editor/prism/languages/tsx'
import 'prism-code-editor/prism/languages/yaml'
import 'prism-code-editor/prism/languages/regex'
import 'prism-code-editor/layout.css'


const app = createApp(App);

app.use(pina);
app.use(router);
app.use(ElementPlus);

app.component('svg-icon', SvgIcon);
app.component('page-header', PageHeader);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}

app.mount('#app');

const config = {
    app,
    toMD5, // md5加密
    api, // 接口层
    dialog, // 弹窗类
    auth, // token管理
    util
}

export {
    config
};
